import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { InventarioService } from '../inventario.service';

/*  MOZGÁSOK – bevételezés (beszállítóval, beszerzési árral), kiadás, raktárközi átvezetés, selejtezés.
 *  A tételek vonalkód-olvasással is felvehetők. A számlából / nyugtából és a leltárból keletkezett
 *  mozgások itt látszanak, de csak a forrásuknál rendezhetők. */
@Component({
  selector: 'app-inventario-mozgasok',
  templateUrl: './mozgasok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../inventario-shared.scss'],
})
export class MozgasokComponent implements OnInit, OnDestroy {
  lista: any[] = [];
  cikkek: any[] = [];
  raktarak: any[] = [];
  tipusSzuro = '';
  tol = `${new Date().getFullYear()}-01-01`;
  ig = new Date().toISOString().slice(0, 10);
  uj: any = null;
  reszlet: any = null;
  olvaso = '';
  readonly TIPUSOK: Record<string, string> = { bevet: 'Bevételezés', kiad: 'Kiadás', atvezet: 'Átvezetés', selejt: 'Selejtezés', leltar: 'Leltárkülönbözet', nyito: 'Nyitókészlet' };
  private sub?: Subscription;
  constructor(public inv: InventarioService, private toast: ToastController, private alert: AlertController) {}
  get u() { return this.inv.aktiv.ugyfelId; }
  get ir() { return this.inv.ir; }
  async ngOnInit() { await this.inv.init(); this.sub = this.inv.aktiv$.subscribe(() => this.frissit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async frissit() {
    if (!this.u) return;
    try {
      this.lista = await this.inv.get(`/mozgasok/${this.u}?tol=${this.tol}&ig=${this.ig}${this.tipusSzuro ? '&tipus=' + this.tipusSzuro : ''}`);
      const r: any = await this.inv.get(`/cikkek/${this.u}`);
      this.cikkek = (r.cikkek || []).filter((c: any) => +c.keszletes); this.raktarak = r.raktarak || [];
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni.'); }
  }
  ujNyit(tipus: string) {
    this.uj = { tipus, datum: new Date().toISOString().slice(0, 10), raktar_id: this.raktarak[0]?.id, cel_raktar_id: this.raktarak[1]?.id || null,
      partner_nev: '', hivatkozas: '', megjegyzes: '', tetelek: [] as any[] };
    this.olvaso = '';
  }
  cikk(id: string) { return this.cikkek.find((c) => c.id === id); }
  hozzaad(c: any) {
    const van = this.uj.tetelek.find((t: any) => t.termek_id === c.id);
    if (van) { van.mennyiseg = Number(van.mennyiseg) + 1; return; }
    this.uj.tetelek.push({ termek_id: c.id, mennyiseg: 1, egysegar: this.uj.tipus === 'bevet' ? c.beszerzesi_ar : null, gyariszam: '' });
  }
  olvas() {
    const k = this.olvaso.trim().replace(/[íö]/g, '0');
    const c = this.cikkek.find((x) => x.vonalkod === k) || this.cikkek.find((x) => x.cikkszam === k);
    if (c) { this.hozzaad(c); this.olvaso = ''; } else this.hiba(`Ismeretlen vonalkód: ${k}`);
  }
  valaszt(id: string) { const c = this.cikk(id); if (c) this.hozzaad(c); }
  async ment() {
    try {
      const r: any = await this.inv.post(`/mozgas/${this.u}`, this.uj);
      this.uj = null; this.ok(`Rögzítve: ${r.bizonylatszam}`); await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült rögzíteni.'); }
  }
  async nyit(m: any) { try { this.reszlet = await this.inv.get(`/mozgas/${this.u}/${m.id}`); this.reszlet.raktar_nev = m.raktar_nev; this.reszlet.cel_raktar_nev = m.cel_raktar_nev; } catch { /* */ } }
  async torol() {
    const a = await this.alert.create({ header: 'Mozgás törlése', message: `Törlöd: ${this.reszlet.bizonylatszam}? A készlet visszaáll.`,
      buttons: [{ text: 'Mégse', role: 'cancel' }, { text: 'Törlés', role: 'destructive', handler: async () => {
        try { await this.inv.del(`/mozgas/${this.u}/${this.reszlet.id}`); this.reszlet = null; this.ok('Törölve.'); await this.frissit(); }
        catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
      } }] });
    await a.present();
  }
  szam(v: any) { return v == null ? '' : Number(v).toLocaleString('hu-HU', { maximumFractionDigits: 2 }); }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4200, color: 'danger' })).present(); }
}
